import OfficeDetails from './OfficeDetails';
import { OfficeDetailsProps } from './OfficeDetails.interface';
export { OfficeDetails };
export type { OfficeDetailsProps };